// @mui
import { Box, Stack } from '@mui/material';

import Iconify from '../../iconify';
//
import { useSettingsContext } from '../SettingsContext';
import { StyledCard } from '../styles';

const StretchOptions = () => {
  const { onToggleStretch, themeStretch } = useSettingsContext();

  return (
    <StyledCard
      onClick={onToggleStretch}
      selected={themeStretch}
      sx={{ height: 48, px: 1 }}
    >
      <Stack
        alignItems="center"
        direction="row"
        justifyContent="space-between"
        sx={{
          transition: (theme) => theme.transitions.create('width'),
          width: 0.24,
          ...(themeStretch && {
            width: 0.5,
          }),
        }}
      >
        <Iconify
          icon={
            themeStretch
              ? 'eva:arrow-ios-back-fill'
              : 'eva:arrow-ios-forward-fill'
          }
        />

        <Box sx={{ borderBottom: `dashed 1.5px currentcolor`, flexGrow: 1 }} />

        <Iconify
          icon={
            themeStretch
              ? 'eva:arrow-ios-forward-fill'
              : 'eva:arrow-ios-back-fill'
          }
        />
      </Stack>
    </StyledCard>
  );
};

export default StretchOptions;
